export default __webpack_public_path__ + "static/media/tissot.9646c2a8.png";